import { tx, createNativeInstance } from '@transifex/native';
import type { TxNative } from '@transifex/native';

export const TX_TOKEN = '1/4435bd02ba6df8cca225decb4855181de5350379';

export const defaultTxInstance = tx;

export const transifexNativeInit = (txInstance: TxNative | void) => {
  const targetTxInstance = txInstance || tx;

  targetTxInstance.init({
    token: TX_TOKEN,
  });
};

const createTxInstance = () => {
  const txInstance = createNativeInstance();
  transifexNativeInit(txInstance);
  return txInstance;
};

const customTxInstances = new Map<string, TxNative>();

export const getTxInstance = (scope: string): TxNative => {
  if (!customTxInstances.has(scope)) {
    const txInstance = createTxInstance();
    customTxInstances.set(scope, txInstance);
  }

  return customTxInstances.get(scope) as TxNative;
};
